import { ProcessInstanceDetails } from 'api/endpoints/processInstance';
import BaseRepo from 'container/BaseRepo';
import { buildBadRequestApiError } from 'container/helpers/errors';
import { ApiResponseAsync } from 'container/models';
import { SuspendedProcessInstanceTask } from 'features/suspendedProcessInstances/typing';

import { ISuspendedProcessInstanceService } from './ISuspendedProcessInstanceService';

export class SuspendedProcessInstanceService
  extends BaseRepo
  implements ISuspendedProcessInstanceService
{
  getSuspendedProcessInstanceTask = (
    instanceData: ProcessInstanceDetails
  ): ApiResponseAsync<SuspendedProcessInstanceTask> => {
    const link = this.getSuspendedInstanceLink(instanceData);
    if (!link) {
      return Promise.resolve(
        buildBadRequestApiError(
          new Error(
            'link "get suspended process instance task" is not available'
          )
        )
      );
    }

    return this.helpers.handlePost(link.href, {});
  };

  processInstanceIsSuspended(instanceData: ProcessInstanceDetails): boolean {
    return this.getSuspendedInstanceLink(instanceData) !== undefined;
  }

  resumeProcessInstance(
    task: SuspendedProcessInstanceTask
  ): ApiResponseAsync<void> {
    const link = task._links?.['resumeProcessInstance'];
    if (!link) {
      return Promise.resolve(
        buildBadRequestApiError(
          new Error(
            'link "resume suspended process instance task" is not available'
          )
        )
      );
    }

    return this.helpers.handlePost(link.href, {});
  }

  getSuspendedInstanceLink = (instanceData: ProcessInstanceDetails) => {
    return instanceData._links?.['getSuspendedProcessInstanceTask'];
  };
}
